module.exports = __webpack_public_path__ + "static/img/child-menu.fcd2155.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/child-menu.png
// module id = sU0n
// module chunks = 5